import { Stack } from '@fluentui/react';
import React from 'react';
import { BaseState } from '../../machine';
import { RemoteMessage } from '../RemoteMessage';

export interface RemoteInputProps<TState extends BaseState> {
  children?: React.ReactNode;
  state: TState;
  logo?: string;
}

export const RemoteInput = <TState extends BaseState>(
  props: RemoteInputProps<TState>
): JSX.Element => {
  const { state, logo } = props;

  const messageText = state?.meta[state.value.toString()]?.message;

  // Guard to ensure that once we have the response for a component, it is not
  // rendered again.
  // const response = state?.context?.responses
  //   ? state?.context?.responses[state.value.toString()]
  //   : undefined;

  const response = undefined;

  return (
    <Stack>
      {messageText && (
        <div>
          <RemoteMessage text={messageText} logo={logo} />
          <br />
        </div>
      )}
      {response ? undefined : props.children}
    </Stack>
  );
};
